<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0 justify-content-end">
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <SingleOptionDropdown class="flex-grow-1" v-model="selectType" :options="poisType" :title="$t('type')" :index="0"></SingleOptionDropdown>
      </div>
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="ADD_ACTION">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="caption" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '@/controls/PaginatedTable.vue'
import SearchBar from '@/controls/SearchBar.vue'
import router from '@/router';
import InputGetPoisList from "@/classes/InputGetPoisList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase, formatDate } from "@/helpers/utils.js";
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'

export default {
  components: { CTableWrapper, SearchBar, SingleOptionDropdown },
  data () {
    return {
      searchText: '',
      caption: i18n.t('pois'),
      currentPage: 1,
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'id', label: i18n.t('id'), _classes: 'font-weight-bold', sortable: true },
        { key: 'title', label: i18n.t('name'), _classes: 'font-weight-bold', sortable: true },
        { key: 'publishDate', label: i18n.t('publishDate'), sortable: true },
      ],
      actions: [
        { key: 'view', label: i18n.t('view') },
        { key: 'remove', label: i18n.t('remove') }
      ],
      sorterValue: { column: 'id', asc: true },
      loading: false,
      selectType: null,
      poisType: [ {label: this.$t("whatToVisit"), key: "See"}, {label: this.$t("whereToEat"), key: "Eat"}, {label: this.$t("whereToStay"), key: "Stay"}],
    }
  },
  computed: {
    ...mapState('pois', ['getPoisOutput']),
    ...mapState('pois', ['deletePoiByIdOutput']),
    poiInfo: function() {
        return this.getPoisOutput ? this.getPoisOutput : null;
    },
    items: function()
    {
      var result = [];

      if(this.poiInfo && this.poiInfo.data)
      {
        result = this.poiInfo.data;

        result.forEach(poi => {
          poi["publishDate"] = formatDate(poi.publishDate);
        });
      }

      return result;
    },
    pages: function()
    {
      return this.poiInfo ? this.poiInfo.totalPages : 1;
    }
  },
  mounted: function()
  {
    this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    ...mapActions('pois', ['getPois']),
    ...mapActions('pois', ['deletePoiById']),
    rowClicked (item, index) {
        this.$router.push({ name: "PoiEdit", query: { id: item.id, type: this.selectType }, params: { name: item.name } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({ name: "PoiEdit", query: { id: item.id, type: this.selectType }, params: { name: item.name } });
          break;
        }
        case 'remove':
        {
          if(confirm(this.$i18n.tc('confirmRemove', item.title, { name: item.title }))){
            this.deletePoiById(item.id);
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.currentPage = currentPage
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetPoisList( itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));
      // List specific parameters
      input.type = this.selectType;
  
      this.getPois(input); 
    },
    ADD_ACTION () 
    {
      router.push({ name: 'PoiAdd', query: { type: this.selectType }});
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }    
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    deletePoiByIdOutput: function(val)
    {
      this.loading = true;
      if(val)
      {
        this.updateItemsRequested(this.currentPage, this.itemsPerPage);
      }
    },
    getPoisOutput:
    {
      handler(val)
      {
        if(val != null)
        {
          this.selectType ? this.selectType : this.selectType = "See";
          this.loading = false;
        }
      },
      deep: true,
      immediate: true
    },
    selectType(val)
    { 
      if(val)
      {
        this.$refs.table.reset();
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style> 